// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hydro-grouped-basic-card__body-text {
  text-align: center;
}

.hydro-grouped-basic-card__heading h3 {
  font-family: var(--fmc-type-family) !important;
  font-size: 24px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/TabbedSection/TabbedSection.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AACA;EACI,8CAAA;EACA,0BAAA;AAEJ","sourcesContent":[".hydro-grouped-basic-card__body-text {\n    text-align: center;\n}\n.hydro-grouped-basic-card__heading h3 {\n    font-family: var(--fmc-type-family) !important;\n    font-size: 24px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
